/**
 * Distribution Application Service Hook
 *
 * This hook provides access to the distribution application service.
 * It follows the clean architecture pattern by abstracting the service layer.
 *
 * @module useDistributionApplicationService
 */

import {useMemo} from 'react';
import {DistributionContainer} from '../application/container/DistributionContainer';
import {IDistributionApplicationService} from '../application/interfaces/IDistributionApplicationService';

/**
 * Hook to get the distribution application service
 *
 * @returns The distribution application service instance
 */
export const useDistributionApplicationService = (): IDistributionApplicationService => {
  return useMemo(() => {
    const container = DistributionContainer.getInstance();
    return container.getDistributionApplicationService();
  }, []);
};
